import React from "react";
import {toast} from "react-toastify";
import Utils from "../../../../utils/utils";
import LatePickUpController from "../../../../services/system/late-pick-up/late-pick-up-controller";
import {Modal} from "react-bootstrap";
import DatePicker from "react-datepicker";
import LatePickUpCheckController from "../../../../services/system/late-pick-up-check/late-pick-up-check-controller";
import {getSchoolYear} from "../../../../utils/authority";
import moment from "moment";

class ModalCreateLatePickUpCheck extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pickUpTime: new Date(),
            listData: [],
            fromDate: '',
            toDate: '',
            pickUpPerson: '',
            name: '',
            latePickUpId: -1,
            day: 0,
            month: 0,
            year: 2023,
            price: 0,
            status: true,
            state: "ACTIVE"
        };
    }
    componentWillMount() {
        this.getListLatePickUp()
    }
    getListLatePickUp() {
        let payload = {
            pageNumber: 0,
            pageSize: 100,
            state: this.state.state,
            sort: "created_at desc"
        };
        LatePickUpController.list(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({
                pickUpTime: new Date(),
                studentId: nextProps.id,
                classRoomId: nextProps.classRoomId,
                day: nextProps.day,
                month: nextProps.month,
                year: nextProps.year,
            })
        }
    }
    createLatePickUp = () => {
        let payload = {
            "day": this.state.day,
            "month": this.state.month,
            "year": this.state.year,
            "pickUpTime": moment(this.state.pickUpTime).format("yyyy-MM-DD HH:mm:ss"),
            "studentId": parseInt(this.state.studentId),
            "classId": parseInt(this.state.classRoomId),
            "latePickUpId": parseInt(this.state.latePickUpId),
            yearId: parseInt(getSchoolYear()),
            "pickUpPerson": this.state.pickUpPerson
        }
        LatePickUpCheckController.create(payload, res => {
            if (res.success) {
                toast.success("Thêm cấu hình đón muộn thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    renderLatePickUp() {
        return this.state.listData.map((item, index) => <option
            value={item.id}>{item.code}-({item.startHour}:{item.startMinute}-{item.endHour}:{item.endMinute})-(Giá: {Utils.formatMoney(item.price)}đ)</option>)
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Chọn giờ đón</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mb-20 mt-20'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Chọn giờ đón(<span  style={{color: "red",}}>*</span>)</label>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.pickUpTime === '' ? null : this.state.pickUpTime}
                                        minDate={new Date()}
                                        dateFormat="dd-MM-yyyy HH:mm"
                                        timeFormat="HH:mm"
                                        timeIntervals={5}
                                        showTimeSelect
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                try {
                                                    this.setState({
                                                        pickUpTime: date,
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-12 label-item pl-0">Chọn mức giá</label>
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex">
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.latePickUpId}
                                        onChange={(e) => {
                                            this.setState({
                                                latePickUpId: e.target.value
                                            })
                                        }}
                                    >
                                        <option value="">Chọn giá</option>
                                        {this.renderLatePickUp()}
                                    </select>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-12 label-item pl-0">Tên người đón/Chú thích</label>
                                </div>
                                <input
                                    maxLength={255}
                                    type="text"
                                    placeholder="Tên người đón/Chú thích"
                                    className="form-control shadow-none"
                                    value={this.state.pickUpPerson}
                                    onChange={(event) => {
                                        this.setState({
                                            pickUpPerson: event.target.value
                                        })
                                    }}
                                />
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.createLatePickUp()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Đóng
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalCreateLatePickUpCheck